import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import EventEmitter from "../../../services/event-emitter";
import AbbreviateNumber from "../../../components/ui-building-blocks/numbers/AbbreviateNumber";
import NumberFormat from "react-number-format";
import _ from "lodash";
import {
  batchRequest,
  postRequest,
  putRequest,
  deleteRequest
} from "../../../api/ApiService";
import { logError } from "../../../services/utils";
import HelpIconButtonWithTooltipAndTypeformModal from "../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import { Loader } from "react-loaders";
import {
  incrementUnacceptedDecisions,
  decrementUnacceptedDecisions
} from "../../../api/SubmitDecisions";
import TypeformContent from "../../typeform/TypeformContent";
import { getRequest } from "../../../api/ApiService";
import Fragment from "react-dot-fragment";
import SuccessAlert from "../../alerts/success";
import ErrorInlineAlert from "../../alerts/errorInline";
import WarningAlert from "../../alerts/warning";

const DEBT_CLIENTS_URL = `${process.env.REACT_APP_API_URL}static/debt_clients/`;
const DEBTS_URL = `${process.env.REACT_APP_API_URL}team/debts/`;
const EQUITY_CLIENTS_URL = `${process.env.REACT_APP_API_URL}static/equity_clients/`;
const EQUITIES_URL = `${process.env.REACT_APP_API_URL}team/equities/`;
const PRE_MONEY_URL = `${process.env.REACT_APP_API_URL}team/pre_money/`;
const PERFORMANCE_MONEY_URL = `${process.env.REACT_APP_API_URL}team/performance_money/`;
const EQUITY_KEY = "GBorGH Ventures";
const DEFAULT_ISSUANCE = 200000;
const AUTHORIZED_SHARES = `${process.env.REACT_APP_API_URL}static/constants/`;
const OUTSTANDING_SHARES = `${process.env.REACT_APP_API_URL}team/post_money/`;

const numberWithCommas = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

class RaiseEquityModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      max_share_issuance: 0,
      issuance: 0,
      prev_issuance: 0,
      equity_id: 0,
      amount: 0,
      share_price: 0,
      client_id: 0,
      loans: [],
      loading: true,
      saving: false,
      authorizedShares: "",
      initialShares: "",
      shares: "",
      showAreYouSure: false,
      successMessage: null,
      errorMessage: null,
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showSuccessMessage = successMessage => {
    this.setState({
      successMessage,
    }, () => {
      this.hideSuccessMessage();
    });
  }

  hideSuccessMessage = () => {
    setTimeout(() => {
      this.setState({
        successMessage: null,
      });
    }, 5000);
  }

  showErrorMessage = errorMessage => {
    this.setState({
      errorMessage,
    }, () => {
      this.hideErrorMessage();
    });
  }

  hideErrorMessage = () => {
    setTimeout(() => {
      this.setState({
        errorMessage: null,
      });
    }, 5000);
  }

  showAreYouSure = () => {
    const {
      issuance,
      authorizedShares,
      initialShares,
      max_share_issuance
    } = this.state;
    const { roundNumber } = this.props;

    const initialMax = authorizedShares - initialShares;
    if ((roundNumber === 1 && issuance > initialMax) || (roundNumber > 1 && issuance > max_share_issuance)) {
      this.showErrorMessage('Share issuance cannot exceed the available shares to issue');
      return;
    }

    if (roundNumber === 1) {
      this.submit();
    } else {
      this.setState({
        showAreYouSure: true,
      });
    }
  };

  hideAreYouSure = () => {
    this.setState({
      showAreYouSure: false,
    });
  };

  get roundId() {
    const { roundNumber, rounds } = this.props;
    const round = rounds.find(i => i.number === roundNumber);

    return round ? round.id : 0;
  }

  fetchShares = () => {
    const { roundNumber } = this.props;

    getRequest(AUTHORIZED_SHARES).then(res => {
      this.setState({
        authorizedShares: res.body[0].authorized_shares,
        initialShares: res.body[0].initial_shares,
      });
    });

    getRequest(OUTSTANDING_SHARES + `?round_number=${roundNumber}`).then(
      res => {
        this.setState({
          shares: res.body[0].shares
        });
      }
    );
  };

  fetchData = () => {
    const { roundNumber, currentRound } = this.props;

    batchRequest([
      DEBT_CLIENTS_URL + `?round_number=${roundNumber}`,
      DEBTS_URL + `?round_number=${roundNumber}`,
      EQUITY_CLIENTS_URL + `?round_number=${roundNumber}`,
      EQUITIES_URL + `?round_lte=${roundNumber}`,
      PRE_MONEY_URL,
      PERFORMANCE_MONEY_URL + `?round_number=${currentRound - 1}`,
      AUTHORIZED_SHARES + `?authorized_shares`
    ])
      .then(res => {
        if (
          res[0].statusCode !== 200 ||
          res[1].statusCode !== 200 ||
          res[2].statusCode !== 200 ||
          res[3].statusCode !== 200 ||
          res[4].statusCode !== 200 ||
          res[5].statusCode !== 200
        ) {
          throw res;
        }

        const debt_clients = res[0].body;
        const debts = res[1].body;
        const equity_clients = res[2].body;
        const equities = res[3].body;
        const pre_money = res[4].body;
        const performance_money = res[5].body;

        let issuance = currentRound === 1 ? DEFAULT_ISSUANCE : 0;
        let equity_id = 0;
        let amount = 0;
        let client_id = 0;

        const equity_client = equity_clients.find(i => i.name === EQUITY_KEY);
        if (equity_client) {
          client_id = equity_client.id;

          const equity_data = equities.find(
            i => i.client === client_id && i.round === this.roundId
          );
          if (equity_data) {
            issuance = equity_data.issuance;
            equity_id = equity_data.id;
          }

          amount = _.sumBy(
            equities.filter(i => i.client === client_id),
            "capital"
          );
        }

        let max_share_issuance = 0;
        let share_price = 0;

        if (pre_money.length > 0) {
          max_share_issuance = pre_money[0].max_share_issuance;
          share_price = pre_money[0].share_price;
        }

        if (performance_money.length > 0) {
          share_price = performance_money[0].share_price;
        }

        let loans = debt_clients.map(debt_client => {
          const client_id = parseInt(debt_client.id, 10);
          const term = client_id === 2 || client_id === 3 ? 5 : 1;
          const debt = debts.find(i => i.client === client_id);

          return {
            name: debt_client.name,
            amount: debt ? debt.amount : 0,
            term: debt ? debt.term : term,
            lt_debt_to_capital: debt_client.lt_debt_to_capital,
            st_debt_to_capital: debt_client.st_debt_to_capital,
            is_prev: debt && debt.prev_round_amount !== 0 ? true : false
          };
        });

        this.setState({
          issuance,
          prev_issuance: issuance,
          equity_id,
          amount,
          client_id,
          max_share_issuance,
          share_price,
          loans,
          loading: false,
          saving: false
        });
      })
      .catch(err => {
        logError(err, "RaiseEquityModal", "fetchData");
      });
  };

  close = () => {
    this.setState({
      show: false
    });
  };

  show = () => {
    this.setState(
      {
        show: true
      },
      () => {
        this.fetchData();
        this.fetchShares();
      }
    );
  };

  componentDidMount() {
    this.eventemitter.on("show-raise-equity-modal", this.show);
  }

  componentWillUnmount() {
    this.eventemitter.off("show-raise-equity-modal", this.show);
  }

  get maxShareIssuance() {
    const { max_share_issuance } = this.state;

    return max_share_issuance;
  }

  get issuance() {
    const { issuance } = this.state;

    return issuance;
  }

  get sharePrice() {
    const { share_price } = this.state;

    return share_price.toFixed(2);
  }

  get capitalRaised() {
    const { amount } = this.state;

    return amount.toFixed(0);
  }

  changeIssuance = (event, value) => {
    const issuance = value ? value.floatValue : Number(event.target.value);
    const prev_issuance = this.state.issuance;

    this.setState({
      issuance,
      prev_issuance
    });
  };

  getEquitiesRequest = () => {
    const { equity_id, client_id, issuance } = this.state;
    let url = `${process.env.REACT_APP_API_URL}team/equities/`;

    if (issuance === 0) {
      if (equity_id > 0) {
        url += equity_id + "/";

        return deleteRequest(url);
      }

      return null;
    }

    const data = {
      client: client_id,
      issuance: issuance
    };

    if (equity_id > 0) {
      url += equity_id + "/";

      return putRequest(url).send(data);
    }

    return postRequest(url).send(data);
  };

  showPopup = share_price => {
    this.eventemitter.trigger("coaching-feedback", [
      "Issuing Ownership",
      <Fragment>
        Make it rain! Raise that equity! But don’t forget, you are issuing a lot
        of shares at a very low price of {share_price}.
        <br />
        <br />
        Pop quiz: If you expect your business value to increase over time (i.e.
        expect your share price to go up), would you rather issue so many
        ownership shares at {share_price} or at a higher price when you have
        created value?
        <br />
        <br />
        Also increasing the # of shares issued can impact your share price if
        your valuation does not increase as well.
        <br />
        <br />
        Note 1: Share Price = Business Value / Shares Outstanding
        <br />
        Note 2: Share Price = a key grading metric
      </Fragment>
    ]);
  };

  showPopup2 = (share_price, capital) => {
    this.eventemitter.trigger("coaching-feedback", [
      "Issuing Ownership",
      <Fragment>
        Very Interesting. You’re only raising ${numberWithCommas(capital)} of
        equity capital! I get it, you don’t want to issue ownership shares at
        this very low price of {share_price}, but is that enough equity to
        raise? You could try to raise your remaining capital needs through debt,
        but your borrowing limits is based on your equity raised (i.e. the more
        equity raised, the more money lenders will lend).
        <br />
        <br />
        To learn more about your capital raising limits, please read The Investor section of the Business Case.
      </Fragment>
    ]);
  };

  submit = () => {
    const { reloadData } = this.props;

    this.setState({
      showAreYouSure: false,
      saving: true
    });

    const equitiesRequest = this.getEquitiesRequest();
    if (equitiesRequest) {
      equitiesRequest
        .then(res => {
          let issuance = 0;
          let capital = 0;
          let share_price = 0;

          if (res.body) {
            issuance = res.body.issuance;
            capital = res.body.capital;
            share_price = `$${(capital / issuance).toFixed(2)}`;
          }

          if (issuance > 4500000) {
            this.showPopup(share_price);
          } else if (issuance <= 1000000) {
            this.showPopup2(share_price, capital);
          }

          this.setState(
            {
              saving: false
            },
            () => {
              if (issuance === 0) {
                decrementUnacceptedDecisions("finance");
              } else {
                incrementUnacceptedDecisions("finance");
              }
              this.showSuccessMessage((
                <Fragment>
                  <b>{(capital).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    maximumFractionDigits: 0,
                  })}</b> of equity capital raised successfully
                </Fragment>
              ));

              reloadData();
              this.fetchData();
            }
          );
        })
        .catch(err => {
          if (
            err.response &&
            err.response.status === 400 &&
            "non_field_errors" in err.response.body &&
            err.response.body["non_field_errors"].length > 0 &&
            err.response.body["non_field_errors"][0] === "No CEO Projections"
          ) {
            this.showErrorMessage('Show us your projections and we\'ll show you the money.');
            this.setState({
              saving: false
            });
            return;
          }

          if (
            err.response &&
            err.response.status === 400 &&
            "issuance" in err.response.body &&
            ((_.isArray(err.response.body["issuance"]) &&
              err.response.body["issuance"].length > 0) ||
              _.isString(err.response.body["issuance"]))
          ) {
            this.showErrorMessage('This decision will result in breaching your lender(s) debt to capital ratio limit');
            this.setState({
              saving: false
            });
            return;
          }

          if (!err.response) {
            console.error(err);
          }

          logError(err, "RaiseEquityModal", "submit");
        });
    } else {
      this.setState({
        saving: false,
      }, () => {
        reloadData();
        this.fetchData();
      });
    }
  };

  render() {
    const { show, loading, saving, showAreYouSure, successMessage, errorMessage } = this.state;
    const { currentRound } = this.props;

    return show ? (
      <Fragment>
        {showAreYouSure && <WarningAlert
          title="ARE YOU SURE?"
          message={(
            <div>
              Are you sure you want to issue additional shares? You might not
              be able to modify and reduce these shares if that reduction
              results in a breach of your lender's debt to capital
              requirement.
              <br />
              <br />
              For more information on each lender's debt to capital
              requirement, please review{" "}
              <a
                href={`/analysis/bcase/modal-exhibit5?round=${currentRound}`}
                target="_blank"
                rel="noreferrer"
              >
                Exhibit 5
              </a>{" "}
              of the business case.
            </div>
          )}
          onSuccess={this.submit}
          onCancel={this.hideAreYouSure}
        />}
        {!showAreYouSure && (
          <Modal
            show={true}
            onHide={this.close}
            dialogClassName="modal-dialog-bigger fn-modal-dialog"
          >
            <Modal.Header closeButton={true}>
              <p className="modal-p text-align-left ml-10">
                <b>GBorGH Ventures - Equity Capital</b>
              </p>
            </Modal.Header>
            <Modal.Body>
              {successMessage && <SuccessAlert
                message={successMessage}
                marginTop={1}
                marginBottom={80}
              />}
              {errorMessage && <ErrorInlineAlert
                title="Error"
                message={errorMessage}
                marginTop={1}
                marginBottom={80}
              />}
              {loading === true && (
                <div className="text-center loader-inline">
                  <Loader type="ball-scale-ripple" active />
                </div>
              )}
              {loading === false && (
                <div className="table-responsive fn-decisions-raise-equity">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th>
                          Equity
                          <br />
                          Offering
                          <HelpIconButtonWithTooltipAndTypeformModal
                            iconSize="xs"
                            {...TypeformContent.EQUITY_OFFERING}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="no-align">Authorized Shares</td>
                        <td>
                          <NumberFormat
                            value={this.state.authorizedShares}
                            displayType="text"
                            thousandSeparator=","
                          />
                        </td>
                      </tr>

                      <tr>
                        <td className="no-align">Outstanding Shares</td>
                        <td>
                          <NumberFormat
                            value={this.state.shares}
                            displayType="text"
                            thousandSeparator=","
                          />
                        </td>
                      </tr>

                      <tr style={{ borderTop: "2px solid black" }}>
                        <td className="no-align">Available Shares to Issue</td>
                        <td>
                          <NumberFormat
                            value={this.state.max_share_issuance}
                            displayType="text"
                            thousandSeparator=","
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="no-align shares-to-issue">
                          Shares To Issue
                        </td>
                        <td>
                          <AbbreviateNumber
                            name="shares_of_issue"
                            type="input"
                            value={this.issuance}
                            onChange={this.changeIssuance}
                            prefix=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="no-align">Price Per Share</td>
                        <td>
                          <NumberFormat
                            value={this.sharePrice}
                            displayType="text"
                            thousandSeparator=","
                            decimalSeparator="."
                            prefix="$"
                          />
                        </td>
                      </tr>

                      <tr>
                        <td>&nbsp;</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-save"
                            onClick={this.showAreYouSure}
                            disabled={saving}
                          >
                            {saving === true ? "Loading..." : "Save"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-close-modal"
                            onClick={this.close}
                            style={{
                              marginLeft: 20
                            }}
                          >
                            Close
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="no-align capital-raised">Capital Raised</td>
                        <td className="capital-raised">
                          <NumberFormat
                            value={this.capitalRaised}
                            displayType="text"
                            thousandSeparator=","
                            prefix="$"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </Modal.Body>
          </Modal>)}
      </Fragment>
    ) : null;
  }
}

export default RaiseEquityModal;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/raise-equity-modal.js